import { memo } from 'react';
import Icon from '@ant-design/icons';

import { LightningFilledSvg } from 'features/day-trade/components/Icons';
import { ForcedSellMapper } from 'global/Securities/types/store/order';

import { BadgeWrapper } from './component.styled';

interface DayTradeBadgeBoxProps {
  label: string;
  isDayTrade?: boolean;
}

function DayTradeBadgeBox({
  label,
  isDayTrade = false,
}: DayTradeBadgeBoxProps) {
  const isForcedSell = !!ForcedSellMapper[label] || isDayTrade;

  const getBadgeLabel = () => {
    if (isForcedSell && isDayTrade) return label;
    if (isForcedSell) return ForcedSellMapper[label];
    return 'DT';
  };

  return (
    <BadgeWrapper isForcedSell={isForcedSell}>
      <Icon component={LightningFilledSvg} />

      {getBadgeLabel()}
    </BadgeWrapper>
  );
}

export default memo(DayTradeBadgeBox);
